import { AxiosError } from 'axios';
import { openErrorNotification } from 'hyarchis-global';
import { HcsAPI } from '..';
import { formatAxiosError } from '../api-error-handler';
import { Workflow, WorkflowAbstract } from '../../../types/workflow';
import mapWorkflow from './mapper';

class WorkflowRepository {
  async get(workflowId: string): Promise<Workflow> {
    try {
      const { data } = await HcsAPI.get<WorkflowAbstract>(`workflows/${workflowId}`);
      return mapWorkflow(data);
    } catch (error) {
      const axiosError = error as AxiosError;
      const message = axiosError.response?.data?.error?.message ?? axiosError.response?.statusText;
      openErrorNotification(`Error occured for workflow ID: ${workflowId}. ${message}`);
      throw formatAxiosError(
        error as AxiosError,
        'An error has occured while retrieving workflow.',
      );
    }
  }
}

export default new WorkflowRepository();
